export function filenameFromContentDisposition(headerValue?: string | null): string | null {
  if (!headerValue) return null;

  // 1) 先抓 filename*
  const star = headerValue.match(/filename\*\s*=\s*([^;]+)/i);
  if (star) {
    try {
      return decodeRFC5987(star[1]);
    } catch {
      // 忽略,試下一個
    }
  }

  // 2) 再抓傳統 filename (支援 RFC2047)
  const normal = headerValue.match(/filename\s*=\s*([^;]+)/i);
  if (normal) {
    try {
      return decodeRFC2047(normal[1]);
    } catch {
      return normal[1].trim().replace(/^"(.*)"$/, '$1');
    }
  }

  return null;
}

export function decodeRFC5987(value: string): string {
  const cleaned = value.trim().replace(/^"(.*)"$/, '$1');
  const match = cleaned.match(/^([^']*)'(?:[^']*)'(.+)$/);
  if (!match) return decodeURIComponent(cleaned);
  const encoded = match[2];
  const decoded = decodeURIComponent(encoded);
  return decoded;
}

export function decodeRFC2047(value: string): string {
  const cleaned = value.trim().replace(/^"(.*)"$/, '$1');

  const r = cleaned.match(/=\?([^?]+)\?([bBqQ])\?([^?]+)\?=/);
  if (!r) {
    return cleaned;
  }
  const charset = r[1].toLowerCase();
  const encoding = r[2].toUpperCase();
  const encoded = r[3];

  let bytes: Uint8Array;

  if (encoding === 'B') {
    // Base64
    const binStr = atob(encoded);
    bytes = new Uint8Array(binStr.length);
    for (let i = 0; i < binStr.length; i++) bytes[i] = binStr.charCodeAt(i);
  } else {
    // Q-encoding: _ 代表空白, =XX 代表位元組
    const q = encoded.replace(/_/g, ' ');
    const percentified = q.replace(/=([0-9A-Fa-f]{2})/g, '%$1');
    const u8 = new TextEncoder().encode(decodeURIComponent(percentified));
    bytes = u8;
  }

  try {
    const decoder = new TextDecoder(charset as any, { fatal: false });
    return decoder.decode(bytes);
  } catch {
    const decoder = new TextDecoder('utf-8', { fatal: false });
    return decoder.decode(bytes);
  }
}